import { chartColors } from "./utils"

// Stacked bar chart
const figure_1_6 = {
  type: "stacked",
  layout: "full",
  figureNumber: "1.6",
  title: "Frequency of Natural Disasters",
  caption: "Climate change has caused a surge in natural disasters.",
  source: "Source: EM-DAT, CRED / UCLouvain, Brussels, Belgium.",
  customLegend: true,
  data: {
    labels: [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    datasets: [
      {
        label: "Landslide",
        borderColor: chartColors(0),
        backgroundColor: chartColors(0),
        data: [
          3, 7, 12, 16, 6, 4, 9, 13, 15, 15, 5, 9, 8, 24, 11, 16, 24, 13, 22,
          18, 27, 24, 20, 21, 15, 13, 20, 10, 12, 29, 32, 17, 13, 11, 15, 20,
          13, 25, 13, 25, 19, 12,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 10,
      },
      {
        label: "Flood",
        borderColor: chartColors(1),
        backgroundColor: chartColors(1),
        data: [
          39, 40, 47, 49, 47, 57, 49, 67, 75, 44, 59, 77, 58, 84, 88, 94, 91,
          95, 94, 122, 157, 156, 172, 157, 127, 193, 226, 218, 165, 151, 184,
          156, 136, 148, 136, 161, 160, 127, 127, 196, 200, 223,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 10,
      },
      {
        label: "Drought",
        borderColor: chartColors(2),
        backgroundColor: chartColors(2),
        data: [
          24, 18, 6, 26, 6, 3, 4, 15, 17, 7, 19, 12, 11, 9, 11, 6, 7, 17, 20,
          26, 25, 22, 24, 14, 11, 20, 9, 11, 16, 18, 21, 16, 18, 9, 20, 27, 14,
          12, 17, 15, 10, 15,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 10,
      },
      {
        label: "Storm",
        borderColor: chartColors(3),
        backgroundColor: chartColors(3),
        data: [
          40, 49, 52, 59, 55, 51, 56, 56, 60, 68, 134, 66, 76, 106, 81, 77, 75,
          79, 86, 103, 101, 105, 122, 85, 121, 130, 76, 101, 112, 87, 94, 81,
          90, 105, 98, 121, 86, 126, 95, 91, 127, 119,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 10,
      },
      {
        label: "Wildfire",
        borderColor: chartColors(4),
        backgroundColor: chartColors(4),
        data: [
          4, 4, 3, 11, 7, 12, 6, 0, 8, 3, 4, 8, 8, 2, 13, 7, 5, 16, 18, 22, 30,
          14, 22, 14, 8, 13, 9, 18, 5, 9, 7, 8, 6, 10, 4, 13, 10, 15, 10, 14, 8,
          19,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 10,
      },
      {
        label: "Extreme temperature",
        borderColor: chartColors(5),
        backgroundColor: chartColors(5),
        data: [
          3, 1, 2, 2, 1, 7, 2, 6, 5, 5, 13, 8, 7, 4, 9, 13, 5, 13, 12, 8, 30,
          23, 15, 25, 16, 40, 14, 25, 16, 20, 28, 16, 52, 13, 17, 12, 12, 10,
          27, 21, 5, 2,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 10,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,
    responsive: true,
    height: "medium",
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: "Number of natural disasters",
          },
          ticks: {
            beginAtZero: true,
            userCallback: function (value, index, values) {
              return value.toLocaleString()
            },
          },
        },
      ],
    },
    legend: { 
      display: false 
    },
  },
}

export default figure_1_6
